import { render } from "./CertificateBody.vue?vue&type=template&id=781de97f"
import script from "./CertificateBody.vue?vue&type=script&lang=js"
export * from "./CertificateBody.vue?vue&type=script&lang=js"
script.render = render

export default script